import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import InitialState, { UpdateProductCategoryAction } from '../redux/product';
import {
  productCategory,
  categoryJsonObj,
  categoryJson,
  product,
  productJsonObj,
  productJson,
  filter,
  filterJSON,
  queryObj,
} from '../../types';

const fetchCategoryApi = async () => {
  const categoryDataObj: categoryJson = await axios.get(
    'https://e-commerce-store-d2bc5-default-rtdb.firebaseio.com/categories.json',
  );
  const actualCategoryData: Array<categoryJsonObj> = [];
  for (const [key, value] of Object.entries(categoryDataObj.data)) {
    if (value) {
      actualCategoryData.push({ ...value, id: +key });
    }
  }
  const filteredCategoryData = actualCategoryData.filter((cat) => cat.parentCategoryId === 'NULL');
  const categoryData: Array<productCategory> = [];
  filteredCategoryData.map((item) => {
    const categoryObj = {
      id: item.id,
      category: item.category,
      subCategory: actualCategoryData
        .filter((x) => x.parentCategoryId === item.id)
        .map((y) => {
          return {
            id: y.id,
            name: y.category,
          };
        }),
    };
    categoryData.push(categoryObj);
  });

  return categoryData;
};

export const fetchCategory = createAsyncThunk('category/fetch', async () => {
  const response: Array<productCategory> = await fetchCategoryApi();
  return response;
});

const fetchProductApi = async () => {
  const productDataObj: productJson = await axios.get(
    'https://e-commerce-store-d2bc5-default-rtdb.firebaseio.com/products.json',
  );
  const categoryData: Array<productJsonObj> = [];
  for (const [key, value] of Object.entries(productDataObj.data)) {
    if (value) {
      categoryData.push({ ...value, id: +key });
    }
  }
  const filteredCategoryData: Array<product> = categoryData.map((item) => {
    return {
      id: item.id,
      categoryId: item.categoryId,
      imageSrc: item.productImage,
      name: item.productName,
      price: item.price,
      description: item.description,
    };
  });

  return filteredCategoryData;
};

export const fetchProduct = createAsyncThunk('product/fetch', async () => {
  const response: Array<product> = await fetchProductApi();
  return response;
});

const buildQuery = (filterObj: filter) => {
  const query: queryObj = {};
  for (const [key, value] of Object.entries(filterObj)) {
    query[key] = value;
  }
  return query;
};

const filterData = (data: Array<product>, query: queryObj) => {
  const keysHavingMinMax = ['price'];
  const filterProduct = data.filter((item: queryObj) => {
    for (const [key] of Object.entries(query)) {
      if (query[key] === undefined) return false;
      else if (keysHavingMinMax.includes(key)) {
        if (query[key]['min'] !== null && item[key] < query[key]['min']) {
          return false;
        }
        if (query[key]['max'] !== null && item[key] > query[key]['max']) {
          return false;
        }
      } else if (!query[key].includes(item[key])) {
        if (query.categoryId.length) {
          return false;
        }
      }
    }
    return true;
  });
  return filterProduct;
};

const applySidebarFilter = (filterObj: filterJSON) => {
  const filterJSON = filterObj;
  const products = filterJSON.products;
  delete filterJSON.products;
  const query = buildQuery(filterJSON);
  let productData: Array<product> = [];
  if (products?.length) {
    productData = filterData(products, query);
  }
  return productData;
};

export const filterProduct = createAsyncThunk('product/filter', async (filterObj: filterJSON) => {
  const response: Array<product> = applySidebarFilter(filterObj);
  return response;
});

const initialState: InitialState = {
  categories: [],
  products: [],
  filteredProducts: [],
  noFilteredProducts: false,
};

export const productCategorySlice = createSlice({
  name: UpdateProductCategoryAction,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCategory.fulfilled, (state, { payload }) => {
      state.categories = payload;
    });
    builder.addCase(fetchProduct.fulfilled, (state, { payload }) => {
      state.products = payload;
      state.filteredProducts = payload;
      state.noFilteredProducts = state.filteredProducts.length === 0;
    });
    builder.addCase(filterProduct.fulfilled, (state, { payload }) => {
      state.filteredProducts = payload;
      state.noFilteredProducts = state.filteredProducts.length === 0;
    });
  },
});

// Action creators are generated for each case reducer function
// export const { applySidebarFilter } = productCategorySlice.actions;
// You must export the reducer as follows for it to be able to be read by the store.
export default productCategorySlice.reducer;
